//header-sticky-js
$(window).scroll(function(){
    if ($(window).scrollTop() >= 1) {
        $('.header').addClass('sticky');
    }
    else {
        $('.header').removeClass('sticky');
    }

// Price person sticky bottom
    if ($(window).scrollTop() >= 1000) {
        $('.person-price-row').addClass('pricesticky');
    }
    else {
        $('.person-price-row').removeClass('pricesticky');
    }
});

$(".flash-banner-btn").click(function(){
    $(".shopnew-freeshipping-outer").hide();
})

// MOBILE MENU
$(document).ready(function() {
    $('.menu-bar').on('click', function() {
        $(this).toggleClass('in').parents('body').toggleClass('mobile-menu');
        $(this).next().toggleClass('in');
    });
    $('.mobile-scroll li.menu-item-has-children').on('click', function() {
        var aftercl = psuedoClick(this);
        var clickafter = psuedoClick(this).after;
        if (clickafter == true) {
            console.log($(aftercl));
            if (!$(this).hasClass('open')) {
                $(this).addClass('open');
                $(this).children('ul').addClass('in');
            } else {
                $(this).find('.sub-menu').removeClass('in');
                $(this).removeClass('open');
                $(this).find('li.open').removeClass('open');
            }
        }
        $('.sub-menu .sub-menu.in li.open').click(function() {
            $(this).removeClass('open');
            $(this).children('.sub-menu.in').removeClass('in');
        })
        console.log($(this).children('.sub-menu'));
    });

    $(document).bind('click', function(e) {
        var $clicked = $(e.target);
        if (!$clicked.parents().hasClass('main-nav')) {
            $('.main-nav').find('.in').removeClass('in');
            $('body').removeClass('mobile-menu');
        }
    });
});
function psuedoClick(parentElem) {

    var beforeClicked,
      afterClicked;

  var parentLeft = parseInt(parentElem.getBoundingClientRect().left, 10),
      parentTop = parseInt(parentElem.getBoundingClientRect().top, 10);

  var parentWidth = parseInt(window.getComputedStyle(parentElem).width, 10),
      parentHeight = parseInt(window.getComputedStyle(parentElem).height, 10);

  var before = window.getComputedStyle(parentElem, ':before');

  var beforeStart = parentLeft + (parseInt(before.getPropertyValue("left"), 10)),
      beforeEnd = beforeStart + parseInt(before.width, 10);

  var beforeYStart = parentTop + (parseInt(before.getPropertyValue("top"), 10)),
      beforeYEnd = beforeYStart + parseInt(before.height, 10);

  var after = window.getComputedStyle(parentElem, ':after');

  var afterStart = parentLeft + (parseInt(after.getPropertyValue("left"), 10)),
      afterEnd = afterStart + parseInt(after.width, 10);

  var afterYStart = parentTop + (parseInt(after.getPropertyValue("top"), 10)),
      afterYEnd = afterYStart + parseInt(after.height, 10);

  var mouseX = event.clientX,
      mouseY = event.clientY;

  beforeClicked = (mouseX >= beforeStart && mouseX <= beforeEnd && mouseY >= beforeYStart && mouseY <= beforeYEnd ? true : false);

  afterClicked = (mouseX >= afterStart && mouseX <= afterEnd && mouseY >= afterYStart && mouseY <= afterYEnd ? true : false);

  return {
    "before" : beforeClicked,
    "after"  : afterClicked

  };

}

